module.exports = __webpack_public_path__ + "img/album15_22.722fcf3e.jpg";